export const BORDERS = {
  subtle: { value: '1px solid {colors.brand.border}' },
  nav: { value: '1px solid {colors.brand.600}' },
  danger: { value: '1px solid {colors.brand.error}' },
};
